<div class="spinner-overlay" *ngIf="loading$ | async">
  <div class="spinner-container">
    <div class="spinner"></div>
    <div class="loading-text">Loading...</div>
  </div>
</div>